import { leurisExportAxios } from '@/axios'

export const requestExport = (year, orgaId, email, format) => {
  let payload = {
    jahr: year,
    orgaId: orgaId,
    email: email,
    format: format
  }
  return new Promise((resolve, reject) => {
    leurisExportAxios('post', payload)
    .then((response) => {
      resolve(response)
    })
    .catch((error) => {
      if (error && error.response && error.response.data && error.response.status) {
        reject(`Error ${error.response.status}: ${error.response.data.error}`)
      } else {
        reject('Error: Server down')
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/leurisExport.js